import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
  cuvetteRemoveItem,
  setCuvetteSealsInScene,
  showMoveMenu,
  setMoveMenu
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].type,
    solution: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].solution,
    hasSolution: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].hasSolution,
    lidId: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].lidId,
    hideControls: state.notebook.protocolSection.scene.apparatus.cuvettes[ownProps.id-1].hideControls,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onRemoveItem: (data)=>{
      dispatch(cuvetteRemoveItem(data))
    },
    setCuvetteSealsInScene: (data)=>{
      dispatch(setCuvetteSealsInScene(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
